
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Image, Flex, Text } from 'rebass';
import { FaImage } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';

export const AvatarImageOrPlaceholder = ({ coverUrl, isSelected, isFromSidebar, borderSize, size, showEdit, ...props }) => (
  <Card
    // bg="cyan-050"
    mr={isFromSidebar ? 0 : 3}
    borderSize={borderSize}
    // borderStyle="solid"
    // borderColor="cyan-050"
    {...props}
    css={`
    height: ${size + 8}px;
    width: ${size + 8}px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: ${isFromSidebar ? "50%" : "0"};
    border: ${isSelected ? "2px solid #9B59B6" : "2px solid transparent"};
    `}
  >
    {showEdit && (
      <Flex
        bg="white"
        p={'4px'}
        css="position: absolute; bottom: 0; right: 0; z-index: 1; border-radius:50%; "
      >
        {/* <Text fontSize={0} color="cyan-300" fontWeight="bold" pr={1}>
          Edit
        </Text> */}
        <Text color="#9B59B6" size={20} as={BiEditAlt} />
      </Flex>
    )}
    {coverUrl && (
      <Image height={size} width={size} src={coverUrl} css={`object-fit: cover; display: block; border-radius: ${isFromSidebar ? '50%' : '0px'};`} />
    )}
    {!coverUrl && <Text as={FaImage} size={size * 0.6} color="cyan-300" />}
  </Card>
);
AvatarImageOrPlaceholder.propTypes = {
  coverUrl: PropTypes.string,
  size: PropTypes.number,
  borderSize: PropTypes.number,
  showEdit: PropTypes.bool,
};
AvatarImageOrPlaceholder.defaultProps = {
  coverUrl: null,
  size: 70,
  borderSize: 4,
  showEdit: false,
};

export default AvatarImageOrPlaceholder;
